import { render, staticRenderFns } from "./ReorderNoteBlock.vue?vue&type=template&id=32f4ff80&"
import script from "./ReorderNoteBlock.vue?vue&type=script&lang=js&"
export * from "./ReorderNoteBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports